<template>
  <div class="addPersonal">
    <QS-scroller-box>
      <QS-h3-title>
        <template #title>{{ customerId ? '编辑' : '新增' }}个人客户</template>
        <div class="splitline" />
      </QS-h3-title>
      <!-- 标签 -->
      <SelectTag title="客户标签"
        v-model="tagList"
        :allTagList="allTagList"
        :currentTagList="currentTagList"
      />
      <!-- 客户基本信息 -->
      <AddCustomerBasicInfo
        ref="AddCustomerBasicInfo"
        :addFormData="addFormData"
        :sourceRequired="false"
      />
      <!-- 驾驶证信息 -->
      <AddDriversLicenseInfo
        ref="AddDriversLicenseInfo"
        :addFormData="addFormData"
        :driverLicenceValidDateRequired="false"
      />
      <!-- 网约人证信息 -->
      <AddHailingLicenceInfo
        ref="AddHailingLicenceInfo"
        :addFormData="addFormData"
      />
      <!-- 支付信息 -->
      <AddPayInfo
        ref="AddPayInfo"
        :addFormData="addFormData"
      />
      <!-- 车服人员 -->
      <AddCarServicerInfo
        ref="AddCarServicerInfo"
        :addFormData="addFormData"
      />
      <!-- 推荐人信息 -->
      <AddReferrerInfo
        ref="AddReferrerInfo"
        :addFormData="addFormData"
      />
      <template #bottomAction>
          <div class="button_container">
            <el-button size="small" @click="cancel"> 取消 </el-button>
            <el-button @click="validateBeforeSubmit" type="primary" size="small">
              {{ customerId ? '提交' : '确认新增' }}
            </el-button>
          </div>
      </template>
    </QS-scroller-box>
  </div>
</template>

<script>
// api
import { checkDriverManagerByCustomer, customerEdit, getCustomerDetail, customerAdd } from '@/api/domain/customers.js'
import { getTenantCustomTagList } from '@/api/domain/others.js'
import SelectTag from '@/components/SelectTag'
import AddCarServicerInfo from '../components/AddCarServicerInfo'
import AddCustomerBasicInfo from '../components/AddCustomerBasicInfo'
import AddDriversLicenseInfo from '../components/AddDriversLicenseInfo'
import AddHailingLicenceInfo from '../components/AddHailingLicenceInfo'
import AddPayInfo from '../components/AddPayInfo'
import AddReferrerInfo from '../components/AddReferrerInfo'

export default {
  components: {
    SelectTag,
    AddCustomerBasicInfo,
    AddDriversLicenseInfo,
    AddHailingLicenceInfo,
    AddPayInfo,
    AddReferrerInfo,
    AddCarServicerInfo,
  },
  data() {
    return {
      allTagList: [], // 所有的自定义标签列表
      tagList: [], // 选中的自定义标签列表（用户选中，传给服务用）
      currentTagList: [], // 已经选中的自定义标签列表（详情查询出来的）
      addFormData: {
        customerType: 1, // 个人客户
      },
      customerId: null,
    }
  },
  methods: {
    cancel(refreshStatus = false) {
      this.$refreshBack(refreshStatus === true)
      this.$router.push({
        path: '/driver/customerManage',
      })
    },
    // 编辑保存
    async submit() {
      let params = {}
      // 获取表单信息
      params.individualCustomerInfo = Object.assign(
        {},
        this.addFormData.individualCustomerInfo,
        this.$refs.AddCustomerBasicInfo.individualCustomerInfo,
        this.$refs.AddDriversLicenseInfo.individualCustomerInfo,
        this.$refs.AddHailingLicenceInfo.individualCustomerInfo,
        this.$refs.AddPayInfo.publicInfo,
      )
      params = Object.assign(
        {},
        this.addFormData,
        params,
        this.$refs.AddCustomerBasicInfo.publicInfo,
        this.$refs.AddReferrerInfo.publicInfo,
      )
      // 长期 改成2099-09-09
      if (params.individualCustomerInfo.driverLicenceValidDate === '长期') {
        params.individualCustomerInfo.driverLicenceValidDate = '2099-09-09'
      }
      if (params.individualCustomerInfo.hailingLicenceValidDate === '长期') {
        params.individualCustomerInfo.hailingLicenceValidDate = '2099-09-09'
      }
      params.individualCustomerInfo.tagList = this.tagList
      const carServicerInfo = this.$refs.AddCarServicerInfo.getParams()
      params.managerId = carServicerInfo.managerId
      params.individualCustomerInfo.vehicleManagerId = carServicerInfo.vehicleManagerId
      delete params.idCardNo
      delete params.contacts
      delete params.individualCustomerInfo.customerType
      delete params.individualCustomerVo
      delete params.manager
      delete params.vehicleManager
      params = this.filterParams(params)
      let res = null
      if (this.customerId) {
        res = await customerEdit(params)
      } else {
        res = await customerAdd(params)
      }
      if (res && res.code === 1) {
        this.$message({
          message: `${this.customerId ? '编辑' : '新增'}成功`,
          type: 'success',
        })
        this.cancel(true)
      }
    },
    // 提交前校验
    async validateBeforeSubmit() {
      const flag = await this.$refs.AddCustomerBasicInfo.validate()
      const driver = await this.$refs.AddDriversLicenseInfo.validate()

      if (flag && driver) {
        // 司管信息校验
        const dmId = this.$refs.AddCarServicerInfo.getParams().managerId
        if (!this.customerId) {
          this.submit()
          return
        }
        const checkResult = await this.dmCheck(dmId)
        if (checkResult.needConfirm) {
          this.$confirm(checkResult.msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'info',
          }).then(() => {
            this.submit()
          }).catch(() => undefined)
        } else {
          this.submit()
        }
      }
    },
    // 司管修改校验
    async dmCheck(dmId) {
      // 如司管信息与之前订单信息不一致（之前没添加过不算），则需要请求接口校验
      const res = await checkDriverManagerByCustomer(this.customerId, dmId)
      // 前后司管不一致，需要弹窗让用户确认
      return {
        needConfirm: res?.code === 1 && !res?.data?.pass,
        msg: res?.data?.failMsg || '校验异常',
      }
    },
    // 获取详情
    getCustomerDetail(id) {
      // customerType 1-个人 2-企业
      getCustomerDetail({ customerType: 1, id }).then((res) => {
        const { code, data } = res
        if (code === 1 && data) {
          const result = this.filterImage(data)
          this.addFormData = result
          const { individualCustomerVo = {} } = result
          const { tagList = [] } = individualCustomerVo
          this.currentTagList = tagList
        }
      })
    },
    // 获取所有标签集合
    getTenantCustomTagList() {
      getTenantCustomTagList({
        type: 2,
      }).then((res) => {
        const { code, data } = res
        if (code === 1) {
          this.allTagList = [...data]
        }
      })
    },
    init() {
      const { id } = this.$route.query
      this.customerId = id
      if (id) {
        this.getCustomerDetail(id)
      }
      this.getTenantCustomTagList()
    },
    normalizeUploadFileList(data) {
      if (typeof data === 'string') {
        const value = data.trim()
        if (!value) return []
        const fileList = this.getEchoUploadFileData(value, true)
        if (fileList.length || value.startsWith('[') || value.startsWith('{')) {
          return fileList
        }
        return this.getEchoUploadFileData([value], true)
      }
      if (data && typeof data === 'object' && !Array.isArray(data)) {
        return this.getEchoUploadFileData([data], true)
      }
      return this.getEchoUploadFileData(data, true)
    },
    // 图片数据格式化
    filterImage(data) {
      const individualCustomerVo = { ...(data.individualCustomerVo || {}) }
      // 身份证-正面
      individualCustomerVo.idCardUrl =
        this.normalizeUploadFileList(individualCustomerVo.idCardUrl)
      // 身份证-背面
      individualCustomerVo.idCardBackUrl =
        this.normalizeUploadFileList(individualCustomerVo.idCardBackUrl)
      // 驾驶证-正面
      individualCustomerVo.driverLicenceUrl =
        this.normalizeUploadFileList(individualCustomerVo.driverLicenceUrl)
      // 驾驶证-背面
      individualCustomerVo.driverLicenceBackUrl =
        this.normalizeUploadFileList(individualCustomerVo.driverLicenceBackUrl)
      // 网约车人证
      individualCustomerVo.hailingLicenceUrl =
        this.normalizeUploadFileList(individualCustomerVo.hailingLicenceUrl)
      return { ...data, individualCustomerVo }
    },
    filterParams(data) {
      const individualCustomerInfo = { ...data.individualCustomerInfo }
      // 身份证-正面
      individualCustomerInfo.idCardUrl =
        this.getUoloadCommonFileData(individualCustomerInfo.idCardUrl)
      // 身份证-背面
      individualCustomerInfo.idCardBackUrl =
        this.getUoloadCommonFileData(individualCustomerInfo.idCardBackUrl)
      // 驾驶证-正面
      individualCustomerInfo.driverLicenceUrl =
        this.getUoloadCommonFileData(individualCustomerInfo.driverLicenceUrl)
      // 驾驶证-背面
      individualCustomerInfo.driverLicenceBackUrl =
        this.getUoloadCommonFileData(individualCustomerInfo.driverLicenceBackUrl)
      // 网约车人证
      individualCustomerInfo.hailingLicenceUrl =
        this.getUoloadCommonFileData(individualCustomerInfo.hailingLicenceUrl)
      return { ...data, individualCustomerInfo }
    },
  },
  mounted() {
    this.init()
  },
}
</script>

<style lang="scss" scoped>
.addPersonal{
  .button_container{
    display: flex;
    justify-content: center;
  }
}
</style>
